import { Container, Grid, Paper } from "@material-ui/core";
import React, { useState } from "react";
import Folder from "../folder/Folder";
import File from "../file/File";
import { IAdminDocument } from "../../../../../@types/documentAdmnstration.types";
import { IDocumentBucketProps } from "../../../../../@types/components/documentBucketProps.types";
import FileInfoDialog from "../dialog/fileInfoDialog/FileInfoDialog";

const DocumentGrid = ({
	gridData,
	handleChangeFolder,
	handleViewImageChange,
	imageDialogProps
}: IDocumentBucketProps) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectDocument, setSelectDocument] = useState<IAdminDocument | null>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelectFile = (document: IAdminDocument) => {
		if (document) {
			setSelectDocument(document);
			handleViewImageChange(document);
		}
	};

	const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
	};
	return (
		<div>
			<Paper elevation={2} style={{ marginTop: "1.5rem", height: "40vh", overflowY: "scroll", padding: 2 }}>
				<FileInfoDialog
					image={imageDialogProps.image}
					handleCloseCallback={imageDialogProps.handleCloseCallback}
					mimeType={imageDialogProps.mimeType}
					openDialog={imageDialogProps.openDialog}
					purpose={imageDialogProps.details}
					title={imageDialogProps.title}
					key={0}
				/>
				{/* <CustomDialog */}
				<Grid spacing={6} style={{ flexGrow: 1 }}>
					<Grid item xs={12} style={{ padding: "2rem", minHeight: "10rem" }}>
						<h2 className="document-grid-header">Folders</h2>
						<Grid container spacing={2}>
							{gridData.map((document, index) => {
								if (document.type === "folder") {
									return (
										<div
											key={index}
											onDoubleClick={() =>
												handleChangeFolder(document._id || "root", document.name)
											}
											// eslint-disable-next-line prettier/prettier
											onContextMenu={e => handleClick(e)}
										>
											<Folder name={document.name} />
										</div>
									);
								}
							})}
							{/* <MenuList
								anchorEl={anchorEl}
								file={selectDocument}
								type={selectDocument?.type || "file"}
								handleClick={handleClick}
								handleClose={handleClose}
								open={open}
							/> */}
						</Grid>
					</Grid>

					<Grid item xs={12} style={{ padding: "2rem" }}>
						<h2 className="document-grid-header">Files</h2>
						<Grid container spacing={2}>
							{gridData.map((document, index) => {
								if (document.type === "file") {
									return (
										<div
											key={index}
											onDoubleClick={() => handleSelectFile(document)}
											// eslint-disable-next-line arrow-parens
											onContextMenu={(e) => handleClick(e)}
										>
											<File name={document.name} />
										</div>
									);
								}
							})}
							{/* <MenuList
								anchorEl={anchorEl}
								file={selectDocument}
								type={selectDocument?.type || "folder"}
								handleClick={handleClick}
								handleClose={handleClose}
								open={open}
							/> */}
						</Grid>
					</Grid>
				</Grid>
			</Paper>
		</div>
	);
};

export default DocumentGrid;
